import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { getMockViewingApplicants } from '../../../RentalPortalViewing.mocks'
import { RentalPortalViewingApplicantsSelect } from '../../../RentalPortalViewingApplicantsSelect'
import {
  QA_NAME_VIEWING_FORM_APPLICANT,
  VIEWING_FORM_FIELD_NAME,
} from '../../RentalPortalViewingFormModal.constants'
import { toViewingFormApplicantItems } from '../../RentalPortalViewingFormModal.utils'
import { ViewingFormApplicantOptionStage } from '../ViewingFormApplicantOptionStage'
import { ViewingFormApplicantSelectDropdownEmpty } from '../ViewingFormApplicantSelectDropdownEmpty'

function ViewingFormApplicantField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const { values } = useFormikContext()

  const listingId = values[VIEWING_FORM_FIELD_NAME.listing]?.value

  return (
    <FormikField
      multi
      Component={FormFieldSelectNG}
      Select={RentalPortalViewingApplicantsSelect}
      apiParams={{ listing_id: listingId }}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('RentalPortal.ViewingFormApplicantPlaceholderKey'),
          },
        },
      }}
      disabled={!listingId}
      emptyValue={EMPTY_LIST}
      fieldComponentProps={{
        label: `${t('RentalPortal.ViewingApplicantsWidgetTitleKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getMockViewingApplicants}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      listProps={{
        Empty: ViewingFormApplicantSelectDropdownEmpty,
        itemProps: {
          contentProps: {
            infoProps: {
              ContentAdditionalData: ViewingFormApplicantOptionStage,
            },
          },
        },
      }}
      name={VIEWING_FORM_FIELD_NAME.applicant}
      qaName={QA_NAME_VIEWING_FORM_APPLICANT}
      toPreparedItems={toViewingFormApplicantItems}
    />
  )
}

export default ViewingFormApplicantField
